import axios from "@/plugins/axios";

export default {
    list(active = true) {
        return axios.httpApi.get("/offer_types/?active=" + active);
    },
};